import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankType = ({ dataField, setDataField, error }) => {
  const {
    iotOrderDetailsSection: { tankType },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldOptions = ['Horizontal', 'Vertical'];
  const fieldHasError = error && !dataField.valueTankType;

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankType}
        items={radioItems}
        checkedId={dataField.valueTankType || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankType: value
        })}
        name="tank-type"
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      <Spacer space={3} />
    </>
  );
};

TankType.propTypes = {
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired
};

export default TankType;
